/*
 * @Author: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @Date: 2024-06-18 10:15:54
 * @LastEditors: liulipeng liulipeng@longfor.com
 * @LastEditTime: 2025-06-09 18:14:14
 * @FilePath: /qd-yunjing-web/src/router/modules/system.ts
 * @Description: 这是默认设置,请设置`customMade`,
 */
import { RouteRecordRaw } from 'vue-router';

import Layout from '@/layouts/index.vue';

export const ossRoutes: RouteRecordRaw[] = [
  {
    path: '/oss',
    name: 'oss-root',
    component: Layout,
    meta: {
      authCodes: ['OPERATION'],
      title: '运维',
    },
    children: [
      {
        path: '/oss/index',
        name: 'oss-index',
        component: () => import('@/views/oss/index.vue'),
        meta: {
          // authCodes: ['OSS_BOARD'],
          authCodes: ['OSS_BOARD'],
          title: '运维看板',
          keepAlive: true,
          activeMenu: '/oss',
        },
      },
      {
        path: '/importExcel/index',
        name: 'oss-importExcel',
        component: () => import('@/views/oss/exportExcel.vue'),
        meta: {
          authCodes: ['ALARM'],
          title: '导入',
          activeMenu: '/oss',
        },
      },
      {
        path: '/oss/realtime',
        name: 'oss-alarm',
        meta: {
          authCodes: ['ALARM'],
          title: '全局告警',
          activeMenu: '/oss',
        },
        children: [
          {
            path: '/oss/realtime',
            name: 'alarm-realtime',
            component: () => import('@/views/oss/alarm/realtime.vue'),
            meta: {
              authCodes: ['REAL_TIME_ALARM'],
              title: '实时告警',
              activeMenu: '/oss',
              isThreeModel: true,
              projectCheckStrictly: true,
            },
          },
          {
            path: '/oss/history',
            name: 'alarm-history',
            component: () => import('@/views/oss/alarm/history.vue'),
            meta: {
              authCodes: ['ALARM'],
              title: '历史告警',
              activeMenu: '/oss',
              projectCheckStrictly: false,
            },
          },
          {
            path: '/oss/quarantime',
            name: 'alarm-quarantine',
            component: () => import('@/views/oss/alarm/quarantine.vue'),
            meta: {
              authCodes: ['ALARM'],
              title: '隔离告警',
              activeMenu: '/oss',
              projectCheckStrictly: false,
            },
          }
        ],
      },
      {
        path: '/oss/accept',
        name: 'oss-accept-index',
        component: () => import('@/views/oss/accept.vue'),
        meta: {
          authCodes: ['ACCEPTANCE_MANAGEMENT'],
          title: '交付验收',
          keepAlive: true,
          activeMenu: '/oss',
        },
      }
    ],
  }
];
